import type { FormlyExtension, FormlyFieldConfig, FormlyFieldProps } from "@ngx-formly/core";

export class FormlyReadonlyExtension implements FormlyExtension {
  static readonly Expression =
    "formState?.readonly === true ? true : (formState?.readonly === false ? false : (field.parent?.props?.readonly || field.props?.readonly))";

  prePopulate(field: FormlyFieldConfig<FormlyFieldProps & Record<string, any>>): void {
    field.expressions ??= {};
    if (field.expressions["props.readonly"] == null) {
      field.expressions["props.readonly"] = FormlyReadonlyExtension.Expression;
    }
  }
}
